/* tslint:disable */
/* eslint-disable */
/**
 * Service joined APIs
 * This is the global API definition for all service apis.
 *
 * The version of the OpenAPI document: 1.2.10
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the InternalCommonPostalAddress interface.
 */
export function instanceOfInternalCommonPostalAddress(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('address1' in value) || value['address1'] === undefined)
        return false;
    if (!('city' in value) || value['city'] === undefined)
        return false;
    if (!('state' in value) || value['state'] === undefined)
        return false;
    if (!('country' in value) || value['country'] === undefined)
        return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined)
        return false;
    return true;
}
export function InternalCommonPostalAddressFromJSON(json) {
    return InternalCommonPostalAddressFromJSONTyped(json, false);
}
export function InternalCommonPostalAddressFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'address1': json['address_1'],
        'address2': json['address_2'] == null ? undefined : json['address_2'],
        'address3': json['address_3'] == null ? undefined : json['address_3'],
        'city': json['city'],
        'state': json['state'],
        'postalCode': json['postal_code'] == null ? undefined : json['postal_code'],
        'country': json['country'],
        'fullName': json['full_name'] == null ? undefined : json['full_name'],
        'defaultBillingAddress': json['default_billing_address'] == null ? undefined : json['default_billing_address'],
        'createdAt': (new Date(json['created_at'])),
        'updatedAt': (new Date(json['updated_at'])),
        'userId': json['user_id'] == null ? undefined : json['user_id'],
    };
}
export function InternalCommonPostalAddressToJSON(json) {
    return InternalCommonPostalAddressToJSONTyped(json, false);
}
export function InternalCommonPostalAddressToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'address_1': value['address1'],
        'address_2': value['address2'],
        'address_3': value['address3'],
        'city': value['city'],
        'state': value['state'],
        'postal_code': value['postalCode'],
        'country': value['country'],
        'full_name': value['fullName'],
        'default_billing_address': value['defaultBillingAddress'],
        'created_at': ((value['createdAt']).toISOString()),
        'updated_at': ((value['updatedAt']).toISOString()),
        'user_id': value['userId'],
    };
}
